var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-notfonund f-tac"},[_c('figure',{staticClass:"figure-img"},[_c('img',{attrs:{"src":require("@/assets/images/icon-404.png"),"width":"100%","height":"100%"}})]),_c('p',{staticClass:"mg-top10 f-fs16"},[_vm._v("程序猿们正在玩命开发中，敬请期待哟~~")])])
}]

export { render, staticRenderFns }